import Swiper from 'swiper/bundle';

jQuery(document).ready(function ($) {
  new Swiper('.simple-slider__slider', {
    direction: 'horizontal',
    loop: false,
    autoplay: {
      delay: 4000,
      pauseOnMouseEnter: false,
    },
    slidesPerView: '1',
    pagination: {
      el: '.simple-slider__pagination',
    },
  });
});